export default "__VITE_ASSET__BKSn8RXy__"